module.exports = {
  "FoodC_check_HTib_sWqA": "Realizando pedido",
  "FoodB_backend_JOOu_ODDV": "ID del firmante",
  "FoodB_2_BPsf_FCjH": "Código postal del contribuyente (nacional)",
  "FoodB_20250414_cwcj_LKFT": "P2",
  "FoodB_CO_hVdF_gzwj": "Matrícula",
  "Gattaran_V1__YaIb": "En línea",
  "Gattaran_V1__xaNO": "Tasa de cancelación",
  "FoodB_2_Please_select_Mixz": "Selecciona",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupones de la tienda",
  "FoodB_0617_DewC_iPTt": "Pedidos completados por día con la competencia - R",
  "Gattaran_REGULAR_xhms_NLbn": "Restablecer",
  "FoodB_up20241218_aEPD_NaLf": "Seleccionar artículos",
  "FoodB_Commision_Add_MPEf": "Agregar",
  "FoodB_survey_wjGW_FMpe": "Asistencia financiera de {{brand_name}}",
  "FoodC_202408_wten_GUVt": "Selecciona la dirección de entrega",
  "FoodB_calculator_CXvv_RJgQ": "Monto a recibir antes de impuestos y comisión",
  "FoodB_tagging_You_chose_OMGB": "Invalidación solicitada por: \"Tienda inexistente\". Para completar el registro, se requiere adjuntar una fotografía.",
  "FoodB_calculator_gRHL_Sgok": "Margen de utilidad",
  "FoodC_homepage_Enter_delivery_IZAu": "Ingresar dirección de entrega",
  "Help_V4_Enter_the_xqlm": "Ingresa un número de celular válido.",
  "FoodC_Card2_When_the_sFOa": "Abre a las",
  "FoodB_Adaptation_GecE_Yvpz": "Nombre de la empresa en la cuenta",
  "FoodB_0_Please_upload_ziBz": "Carga una captura de pantalla del historial de llamadas",
  "FoodB_phrase__NpWx": "Sólo promos finalizadas en los últimos {{number}} meses",
  "FoodB_202303_YWUL_hwNF": "Aceptar",
  "FoodB_0617_pLtb_hIQz": "Pedidos completados por día con la competencia - U",
  "FoodB_0905__dSOH": "Diagnóstico de la tienda",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodB_Contract_UTbX_JhBf": "¿Paridad de Precio Estipulada en Contrato?",
  "FoodB_Show_Store_Direct_GuJM": "Contrato firmado mediante B-App",
  "GRider_dlp_Mjnq_pnxH": "Más información",
  "FoodOpB_Management_Appeals_foxk": "Solicitar revisión",
  "FoodB_accountInfo_NjKP_vPaS": "Negocio",
  "FoodB_optimization__bdZL": "La imagen debe tener un formato JPG o PNG, pesar menos de 5 MB y ser de al menos 200×200 píxeles.",
  "FoodC_202408_HkLu_Mwgv": "No hay permisos de ubicación",
  "soda-c-i18n---个人中心的“优惠券”": " Mi Perfil > Cupones.",
  "FoodB_1106_FGdT_UxXY": "Generando resumen de IA",
  "FoodC_sales_Confirmation_mTGd": "Entendido",
  "FoodC_202408_QAer_OYaB": "¡Te damos la bienvenida!",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. Como parte de nuestro programa de lealtad queremos darte unos cupones en caso de una entrega con demora. Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones gratis. Puedes ver los cupones una vez que se complete el pedido en",
  "FoodC_edit_SkdG_WQKu": "Encontrarse en la recepción del hotel",
  "FoodB_Contract_Jthe_YSbD": "¿Encuesta actualizada?",
  "FoodB_v1_Sources_of_DsXR": "Fuente de información",
  "FoodB_20260130_RUfF_qIDg": "Calificación de la etapa: preparación estratégica",
  "FoodC_education_1_Customers_Gpbb": "1. Antes de realizar un pedido, elige la mejor opción de entrega para ti. Indica al socio repartidor cómo prefieres la entrega del  pedido según la opción que selecciones:",
  "FoodB_B90_TQLE_ZHYV": "Comparación de precios con el competidor",
  "FoodB_1106_uAeK_oOBq": "Por favor, describe el trabajo que hiciste. ¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales? ¿Cuáles son los próximos pasos?",
  "FoodD_Name_April_UHuR": "Abr",
  "soda-c-i18n---现金": "Efectivo",
  "FoodC_20240607_STdK_ZTMu": "Servicio técnico proporcionado por {{brand_name}}",
  "FoodB_202502_ldlj_sqzT": "Enviar",
  "FoodB_20260130_bbxn_DGDm": "Puntuación total",
  "soda-c-i18n---将赔付给您1张%s优惠券": "Obtienes un cupón de %s.",
  "FoodC_20240607_Olbe_DAqS": "No se puede cargar",
  "FoodB_20250414_oAyQ_liSz": "Descuento final",
  "FoodB_1__gcdX": "Datos del evento",
  "FoodB_signing_jYxY_BCDy": "Modificar evidencia",
  "FoodD_payout_Account_Type_YmVW": "Tipo de cuenta",
  "FoodB_requirement_aEIJ_Ryni": "Periodo actual",
  "FoodB_V1_pVrj_FQgt": "Id. del proyecto",
  "FoodB_email_CBNM_cSdr": "Correo electrónico",
  "FoodB_V2_Illegal_companies_pXwb": "No registrada legalmente",
  "Gattaran_Grocery__pKzk": "Shop",
  "FoodC_sidebar_Scan_QR_ONzJ": "Escanea el código QR con la cámara de tu celular",
  "FoodC_sidebar_Use_the_huoZ": "Pide cuando quieras, donde quieras",
  "FoodB_management_Automatic_Switching_ghJS": "Apertura/cierre automático de la tienda",
  "FoodC_education_3_If_wduh": "",
  "FoodB_20260130_Asip_cJgN": "Por favor, ingresa una descripción de al menos 15 caracteres.",
  "FoodB_improvement_NRct_GSoW": "Pasaporte",
  "FoodB_status2_NytC_XUXP": "segundos",
  "FoodD_Name_January_lhYr": "Ene",
  "FoodB_Translation_fqel_jrJX": "Imágenes probatorias (opcional)",
  "FoodB_communications_nVMa_oikA": "Impulso para tiendas nuevas",
  "FoodB_1106_wohA_bqJX": "La IA está realizando el análisis y el resumen. Por favor, vuelve a revisar más tarde.",
  "FoodB_1106_tdLw_uSLP": "Todo",
  "FoodB_email_CuqE_WLmP": "¡Hola! Visitamos tu marca {{brand_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodB_audit_Store_Information_ryuV": "Se realizó una revisión de la información modificada de la tienda",
  "FoodC_202410_ZHQi_kNsP": "Editar",
  "FoodC_c_Completed_djPp": "Finalizado",
  "FoodB_20250414_hanC_RXkJ": "P1*P2",
  "FoodB_others_lLxk_toBG": "Información del representante legal",
  "FoodB_list_Recently_launched_IWDa": "Última vez conectada",
  "FoodB_Contract_CqnW_XWkx": "Nivel de Recompensa de Tarifa de Servicio",
  "FoodB_v4_Ofdy_csVK": "Cobertura de fotos de artículos del menú",
  "FoodC_202408_qXNe_iBNs": "No se pudo obtener la ubicación actual",
  "FoodB_up20241218_Btbi_AOsy": "Enviado",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo es obligatorio",
  "FoodB_governance_OZDM_JqJt": "¿Rectificación completada por violación de comparación de precio (sin mejor precio en DiDi)?",
  "FoodB_optimization_TjHf_zaEo": "No completadas",
  "FoodB_1__IhgO": "Actualizado el {{time}}",
  "FoodB_0617_EuIs_mugQ": "¿Cuántos pedidos con entrega a domicilio realiza el restaurante por día?",
  "FoodB_V1_hSCx_tzLn": "Nombre del proyecto",
  "FoodB_2_ntnh_vUsC": "Correo electrónico del propietario de la empresa",
  "FoodC_202408_uMeD_ECQU": "Hubo un error. Inténtalo de nuevo.",
  "FoodC_Website_From_shop_Jatv": "Realiza un pedido a [shop name] | DiDi Food",
  "FoodB_requirement_puhp_VPIQ": "Pedidos no preparados a tiempo",
  "FoodB_SMS__promotion_EKZy": "Promoción de entrega sin costo",
  "FoodB_pt1_pppx_zdcg": "Número de cuenta bancaria",
  "FoodB_20250612_SduQ_XghF": "Debes ingresar entre uno y 10 dígitos",
  "FoodB_V1_oOpd_aRtv": "No completada",
  "FoodB_up250108_BLxC_rIzf": "Ver después",
  "FoodB_APP_BKjc_PGqI": "Anuncio de tienda",
  "FoodC_202412_DMKw_kWMA": "Intenta buscar la calle y número",
  "FoodB_signing_YTyA_PKap": "Subir imágenes",
  "FoodB_0905__zFVs": "Peso total",
  "FoodB_1106_fJJY_Hpvo": "Volver a grabar",
  "FoodB_statistics__lkdP": "Minuto",
  "FoodB_accountInfo_sstp_wipw": "Personal",
  "FoodC_education_Platform_Delivery_MJPQ": "Entrega a través de la plataforma",
  "Gattaran_visit_zdKK_wwRk": "Resultados de la visita",
  "FoodC_202408_HNlI_lTpJ": "No se ha agregado propina aún",
  "FoodB_audit_Review_process_vGtV": "proceso de revisión. ¿Estás seguro de que quieres continuar?",
  "FoodC_dish_Look_again_fJrp": "Ahora no",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "FoodC_nonaffiliate_Courier_is_iunG": "El socio repartidor va en camino a la tienda para realizar tu pedido.",
  "FoodB_20250414_dobD_hNij": "Tasa de nuevos usuarios",
  "FoodB_20260130_AmlG_nQAn": "Gestionar aspectos operativos y fundamentales",
  "FoodC_202408_IBpM_TxlD": "Otro",
  "FoodB_IGV_iopU_urly": "IGV",
  "必选": "No es posible desactivar",
  "FoodB_calculator_vEpj_lLGl": "Descuento total",
  "FoodB_20250612_GGEs_TCgn": "Debes ingresar 10 dígitos",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodC_202412_QJMa_Qkwg": "Ingresa una nueva dirección de entrega para agregarla",
  "FoodB_document_vGTm_pEcu": "El archivo que se cargará no puede superar los {{limit}} MB. Por favor, vuelve a cargarlo.",
  "FoodB_20260130_jZbm_FSzF": "Capitalizar oportunidades del entorno (enfoque en el negocio)",
  "FoodB_0707_High_prices_fBsL": "Más altos",
  "FoodB_UI_RToR_WdHq": "Cerrar",
  "FoodB_process_kiMF_XkhA": "Confirmación pendiente",
  "FoodB_Show_Tax_payment_xfxh": "Forma de pago de impuestos (Nacional)",
  "FoodB_Optimization_BxoS_KKTP": "No compatible",
  "FoodB_options_bBhm_incO": "Registro único tributario",
  "FoodB_0921__isZD": "Tasa de artículos calificados",
  "FoodB_2_VcBR_ZXSJ": "Nombre del representante legal",
  "确认": "Subir",
  "FoodB_communications_HAnw_bYAw": "tiendas con acciones incompletas",
  "FoodB_fininfo_rljL_FPkz": "Cédula",
  "FoodC_education_3_Customers_Zoec": "3. Para que el socio repartidor pueda contactarte si lo necesita, procura tener tu teléfono a la mano durante la entrega.",
  "FoodB_1106_LmPI_RZuR": "El permiso de registro está desactivado. Por favor, actívalo desde la Configuración.",
  "FoodC_202409_yzRW_xKLM": "Este pedido está cerrado. Para ver los detalles, ingresa el número de teléfono celular del solicitante.",
  "FoodB_1106_tawV_utGy": "Pasos siguientes",
  "FoodC_text_WMkV_qNzN": "Activar",
  "FoodB_B90_fLqG_AkRx": "Comparación de precios en el lugar",
  "FoodC_202412_kamX_bNUi": "Por favor, selecciona una dirección para agregar",
  "FoodC_20240607_fIqe_iMtS": "Aceptar",
  "FoodB_20250414_faVK_FFkd": "Tasa",
  "FoodB_Contract_nsIw_Gfzl": "El precio de {{brand_name}} es {{unit}} {{number}} % del precio de la competencia",
  "FoodB_pt1_MJlX_mhMH": "Nombre de la persona de contacto",
  "FoodB_boarding_Name_of_ofQq": "Nombre del representante legal",
  "FoodB_2_Store_XkLQ": "Tienda",
  "FoodB_progress_eMmv_RfMT": "ID de la tienda",
  "FoodB_Translation_kinT_foeX": "Elige el motivo del estado no resuelto",
  "FoodB_0622_Select_up_QXDl": "Selecciona hasta 2 tiendas",
  "FoodB_1106_isfE_qwXl": "Cargando archivo de voz. No cierres esta página",
  "FoodB_20260130_msue_tVrT": "Actitud y aprendizaje continuo",
  "FoodC_web_Application_Progress_UYtG": "Estado de la solicitud",
  "FoodC_edit_NDmM_lEJY": "Encontrarse en la puerta",
  "FoodC_202408_HfXO_xbcw": "Ver",
  "FoodD_Questionnaire_Postal_KeGa": "Código postal",
  "FoodB_tagging_You_chose_aZCG": "Invalidación solicitada por: \"Cierre de operaciones\". Para proceder, es necesario estar a menos de {{distance}} de la tienda. Favor de verificar la ubicación e intentar de nuevo.",
  "FoodC_education__1_vwgm": "(1) Entregar en la puerta",
  "FoodB_1106_qhrP_Bevz": "¿Qué trabajo se hizo?",
  "FoodB_pt1_qHPJ_nTdz": "Foto del exterior de la tienda",
  "FoodB_resivion_Feedback_to_QmQU": "Repórtalo a tu supervisor para que la modifique",
  "FoodB_task_BFBu_ONmI": "Tarea no ejecutada",
  "FoodB_0926__Jfhv": "No hay promociones con este estado",
  "FoodB_option0721_ZycF_rQOh": "Este es un tipo de restaurante diferente",
  "FoodB_supplement3_Delivery_costs_HbwR": "Tarifa de entrega por parte de la tienda",
  "FoodC_edit_GeFS_ZPLW": "Dirección y nombre del edificio",
  "FoodB_0617_qpbP_bnWv": "Pedidos completados por día - Entrega de la tienda",
  "FoodB_2_PNEX_yvxA": "Información fiscal",
  "FoodC_perception_Tips_hZWk": "Propina",
  "FoodB_0907__jtsj": "No hay datos del diagnóstico",
  "FoodB_20260130_aGfa_zSww": "Profundizar en la escucha activa",
  "FoodB_audit_Similarity_check_cQEP": "Evaluación de similitud",
  "FoodB_Translation_vZUg_djAJ": "Elige el resultado de la resolución",
  "FoodB_group0901_tZIs_QwiK": "Postulado",
  "FoodC_202408_zoCD_Pszh": "Continuar",
  "FoodC_supplement_Return_wVpv": "Atrás",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nombre completo del contribuyente (Nacional)",
  "FoodC_optimization_rmLx_bSmk": "Busca tu dirección de entrega y agrégala",
  "FoodB_APP_kvLF_MMXl": "Pedidos completados diariamente",
  "FoodB_calculator_yiXt_NkiM": "Comisión DiDi",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "Recomendaciones para la entrega",
  "FoodB_addon_MnfP_VIKl": "Premios de tarifa de servicio",
  "FoodB_20231012_Usvn_HuCU": "La tarea se creó con éxito. Puedes seguir el progreso en el módulo Mis tareas.",
  "FoodB_2_FSbr_muxp": "Tipo de identificación",
  "FoodC_revision_Contact_customer_XbFk": "Contáctanos",
  "FoodB_Show_Colombia_Aliens_xrvS": "Cédula de extranjería",
  "FoodB_1106_UJYm_mRFD": "Puedes editar el contenido generado por IA y enviar la grabación final tras la confirmación.",
  "FoodC_shop__hSnf": "Queda(n) {{num}}",
  "FoodOpB_Management_High_similarity_lnFn": "Ya existe una tienda similar",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "FoodB_5_Store_Delivery_PIyN": "Entrega por parte de la tienda",
  "FoodC_202410_mjfG_DDhf": "Agregar",
  "FoodC_page_AAmU_wxJS": "Calificaciones",
  "FoodB_calculator_JGZb_tQiY": "Precio para el usuario",
  "FoodB_field_Do_you_mhOz": "¿Sujeto al pago del IVA local?",
  "FoodB_0905__yxOa": "Sin cambios",
  "FoodC_improvement_Rgol_abYw": "Se envió tu solicitud de cancelación, y la tienda la procesará en un plazo de {{XminYs}}. Gracias por aguardar.",
  "FoodB_survey_IQBT_jfZq": "Fecha de vencimiento del contrato de exclusividad con el competidor – P",
  "FoodB_menu_ezpD_HgJQ": "Entrega",
  "FoodB_B86_UdlE_SMWM": "Confirmar",
  "FoodB_calculator_pEyx_wJvY": "Sí",
  "FoodB_0820__bVDh": "Alta prioridad",
  "FoodB_B86_bcPL_fkRh": "Anteriores",
  "Gattaran_visit_Wpaf_mvuG": "El BD cerró los acuerdos exitosamente",
  "FoodB_20260130_BNSE_KtQJ": "Uso consistente de herramientas de gestión y datos",
  "FoodC_education_5_Cash_zBuY": "5. Si realizas un pedido con pago en efectivo, procura tener suficiente dinero a la mano para pagar el pedido antes de aceptar la entrega.",
  "FoodB_CL_Traditional_companies_cQhK": "Sociedad de sistema tradicional",
  "Groceries_shop2_Fwyu_yymq": "Sólo se puede agregar hasta {{num}} artículos al carrito.",
  "FoodB_1106_vPRw_ajcX": "¿Confirmas que deseas eliminar la grabación?",
  "FoodB_B86_UDxy_zyJV": "Esta tienda no tiene registros de irregularidades durante el periodo actual",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "N° del  contribuyente (Local)",
  "FoodB_20260130_oTtg_HpPm": "Mejorar el conocimiento detallado de los productos y la oferta comercial",
  "FoodC_202408_PvIX_VPCT": "Ingresa para ver ofertas y rastrear tu pedido",
  "FoodB_202309_timO_PnMJ": "Calificaciones",
  "FoodB_1106_zQzq_GRVj": "Este dispositivo no admite grabaciones",
  "FoodB_Tracking_EhUy_AsTJ": "ID del contrato",
  "FoodB_20260130_yite_dEGG": "Se generaron los pasos siguientes con fechas de compromiso",
  "FoodB_20260130_lYVk_IIJb": "Mejorar en manejo de objeciones",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodB_0_SMS_yOMB": "Mensajes de texto",
  "FoodB_calculator_VFoE_zsGK": "Costo del artículo",
  "FoodB_20260130_Lbce_revt": "Conocimiento previo del negocio",
  "FoodC_payment_eCqh_ogxh": "Los pagos en línea aún no están disponibles. Te recomendamos seguir al pendiente.",
  "FoodB_survey_xyMR_sTst": "¿En exclusiva con un competidor? – P",
  "FoodB_V1_daZW_gxxe": "Tipo de proyecto",
  "FoodD_Name_February_bMVM": "Feb",
  "FoodC_202410_Ejdi_makf": "Elige una tienda",
  "FoodB_list_Name_of_dxYm": "Nombre del representante de ventas",
  "Gattaran_REGULAR_UodO_bJVP": "El valor no puede ser mayor a 100",
  "FoodB_v108_Qpgb_cAfC": "Nombre/ID del proyecto",
  "FoodC_202408_Jvou_Cqor": "Lugares cercanos",
  "Gattaran_REGULAR_JVAQ_pbxi": "Entrada básica",
  "FoodB_signing_UqWz_ipbw": "[{{incompletion_reason}}] Sube una imagen o un archivo PDF",
  "FoodB_list_Store_Type_BWbl": "Tipo de tienda",
  "Gattaran_V1__ZtqD": "Ver tutorial de promociones",
  "soda-c-i18n---送您1张%s优惠券；": "Te daremos un cupón de %s.",
  "FoodB_Contract_QbrO_gJzi": "El premio de tarifa de servicio en el acuerdo es {{unit}} {{number}}%",
  "Gattaran_visit_CRcg_FwpW": "No",
  "FoodB_Optimization_yLAo_nFsv": "Foto del interior de la tienda",
  "FoodB_20250414_zXUI_rXee": "Premios de la tienda",
  "FoodB_APP_YjyK_hqYn": "Pedido",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Entendido",
  "FoodB_Dimension_UVvy_UnnT": "Valor promedio de pedido",
  "FoodB_Optimization_QsfU_elzm": "Por favor, selecciona un tipo de tienda",
  "FoodC_optimization_GUGp_fDxe": "Volver",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Visitas en este mes",
  "FoodB_calculator_AioF_coBc": "IVA sobre base gravable",
  "FoodB_time_No_permission_Xxyy": "Sin permisos",
  "FoodB_options_pMML_QUyg": "Permiso de residencia especial",
  "FoodB_up20241218_hGVF_hBSj": "Esta tienda no tiene artículos que cumplan con los requisitos. Sugerimos contactar a la tienda pronto para cargar los artículos.",
  "FoodC_remark_Thank_you_ENoY": "¡Gracias por elegir {{brand_name}}!",
  "FoodB_v108_jDaE_FNvH": "Nombre/ID de la tienda",
  "FoodB_20260130_dqca_vtcE": "Seguimiento y cumplimiento",
  "FoodC_dish_Leaving_LwWJ": "Salir",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodC_202408_IfNx_VyNu": "Direcciones guardadas",
  "FoodC_dish_Current_activity_Iyrv": "Esta promoción termina en {{arrived_time}}. Las promociones para nuevos usuarios ya no estarán disponibles después de esa fecha",
  "FoodB_optimization_Full_reduction_NlOa": "Gasta X, Ahorra Y",
  "FoodC_dish_You_will_AXAT": "Sólo puedes disfrutar de promociones para nuevos usuarios en esta página.",
  "FoodB_boarding_Store_logo_vzJz": "Logotipo de la tienda",
  "FoodB_email_mlcn_NvDS": "Método de contacto preferido",
  "FoodB_20250414_uqsI_JhAj": "P1",
  "FoodC_edit_NwrE_OHgM": "Encontrarse fuera del edificio de apartamentos",
  "FoodB_data_End_mVwX": "Hora de cierre",
  "soda-c-i18n---晚间：%s-%s": "Durante la noche: %s a %s",
  "FoodB_20260130_VWIQ_JMLw": "Habilidades de negociación",
  "FoodB_Validation2_UJDi_eBej": "No se permiten espacios al principio ni al final",
  "FoodB_2_Online_visit_OLuR": "Presencial",
  "FoodB_signing_Jkuq_XEjU": "Si quitas la marca de la casilla, se descartarán las imágenes y los archivos enviados",
  "FoodB_0327_ZGTe_zcKH": "Pulsa aquí para cambiar de ciudad",
  "FoodC_202410_YFVb_hzJK": "Agrega una dirección",
  "Gattaran_V1__WcTv": "Tasa de artículos calificados",
  "FoodB_model20250116_iVfy_zMbV": "Ingreso registrado con éxito",
  "FoodB_improvement_hVwo_FNaC": "Asignación de cuenta bancaria (requerido en algunos casos, ver en parte inferior.)",
  "Gattaran_visit_KjUG_kxHP": "El BD enlista los programas promocionales y revisa las necesidades de la tienda",
  "FoodB_0919__flip": "Artículos disponibles",
  "FoodC_education_1_If_iWDm": "1. Si no te es posible seguir las recomendaciones anteriores para recibir un pedido, podría considerarse que el inconveniente relacionado con la entrega fue tu responsabilidad. Esto incluye, pero no se limita a, situaciones en donde:",
  "FoodB_0617_Blon_MRMe": "Pedidos completados por día - Retiro en tienda",
  "FoodB_audit_Audit_process_asoS": "proceso de revisión. No podrás solicitar una firma hasta que se complete este proceso. ¿Estás seguro de que quieres continuar?",
  "FoodB_20260130_pFZl_PAxD": "A veces",
  "FoodB_calculator_dsiQ_vhFJ": "Monto a recibir",
  "FoodB_2_GvXK_WJUk": "Porcentaje de premio de tarifa de servicio del modo de retiro en tienda",
  "FoodB_V2_No_legal_QONX": "Falta la identificación del representante legal",
  "FoodC_202409_dTTH_bjFQ": "Este pedido se ha completado o no existe, por lo que no puede verse.",
  "FoodB_V1_tdXj_tAvG": "Tareas de la tienda",
  "FoodB_20260130_fEgm_UwHu": "Acompañamiento y seguimiento",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de tienda",
  "FoodB_CO_Bank_flow_KoLX": "Foto de tu estado de cuenta",
  "FoodB_1106_qUmr_XNmN": "Error de carga de la grabación",
  "FoodB_Overview_AasD_LvfW": "Ver más",
  "Gattaran_visit_PQZP_gcOK": "Sí",
  "FoodB_NewStore_Status_HphC": "Estado",
  "FoodC_Website_At_present_XpFw": "En este momento no se puede canjear en la página web. Por favor, canjea el código promocional en la aplicación.",
  "FoodB_list_Store_Phone_tSWo": "Número de teléfono de la tienda",
  "FoodB_202204_Number_of_yYUn": "Pedidos con calificación negativa",
  "FoodB_manager_aCSR_lQaQ": "semana",
  "Gattaran_visit_KNGQ_NwUQ": "El BD enlista los acuerdos anteriores",
  "FoodB_communications_mtxm_YcRA": "tiendas que no completaron las acciones para el impulso de tiendas nuevas",
  "FoodB_V1_zSAb_YlGe": "Queda(n) {{num_days_left}} día(s)",
  "FoodC_edit_bZFb_ghVG": "Encontrarse fuera del edificio del hotel",
  "FoodB_email_KYaO_tHVJ": "Operador de la app",
  "FoodB_Show_Savings_uvSS": "Cuenta de ahorros",
  "FoodB_wording_abRG_GdGn": "Responsabilidades, calidades y atributos",
  "FoodB_20260130_JgHk_zEgk": "Incrementar la efectividad del acercamiento con el DM",
  "FoodB_Sales_NPeL_QUgG": "Ver menos",
  "FoodB_420241024_LTYv_GOfN": "Valor final",
  "FoodB_optimization_Label_nzNw": "Etiqueta",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoría de etiqueta manual",
  "FoodD_supplement_Small_time_ycjv": "hora(s)",
  "FoodB_process_EHJE_CoxL": "Elegir subartículo",
  "FoodB_P0_cNyW_HkyE": "Cambios en pedidos completados",
  "FoodC_edit_OVRs_CzUt": "Hotel",
  "FoodB_list_Store_ID_GNUR": "No. de identificación de la tienda",
  "FoodB_2_kFvZ_brOV": "Información fiscal",
  "FoodB_20230410_YNjt_xAWA": "Tienda DiDi Top",
  "FoodB_system_offline_revV": "Fuera de línea",
  "FoodB_optimization_First_completed_KqBm": "Fecha y hora de finalización de la primera revisión de la tienda",
  "FoodC_202408_leda_oOpl": "Mejor control de pedidos",
  "FoodB_0926__bEjZ": "No hay promociones iniciadas",
  "FoodB_CL_Individuals_VUHt": "Persona física",
  "FoodB_reason_Contact_Courier_Fqog": "Contactar al repartidor",
  "FoodB_V1_LADl_QUme": "Completar formulario",
  "FoodB_20260130_bwfW_jXkh": "Comunicación efectiva",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "FoodB_list_Brand_Name_pGTc": "Nombre de la marca",
  "FoodB_1106_Boir_tlSu": "No se pudo cargar el archivo de audio. Por favor, asegúrate de que tu red sea estable y que el archivo tenga menos de 5 MB y menos de {{max_record_time}} segundos de duración.",
  "sailing.d-api.common.页面获取失败，请稍后重试": "No se puede recuperar la página. Vuelve a intentarlo más tarde.",
  "FoodB_20260130_ifDg_nokH": "Hubo planeación y preparación de la ruta efectuada en el día",
  "FoodB_1106_LrXH_ibej": "Se está generando tu resumen de IA. Puede demorar entre 1 y 5 minutos. Si cierras esta ventana, el proceso continuará. Una vez que se haya completado, puedes verlo en la Información de seguimiento, en la página Detalles de socio potencial.",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones para remediar las cosas. Una vez que se complete tu pedido, puedes ver los cupones en ",
  "FoodB_20260130_oIxI_wIMq": "Dominio del pitch comercial",
  "FoodB_APP_PJrW_uBye": "AOP/ASP",
  "FoodB_statistics_Heaven_fdUv": "Día",
  "FoodB_improvement_FVqj_Hodu": "Comprobante de domicilio de la tienda y/o sucursal",
  "FoodB_v108_QiQv_BLcw": "Nombre de la tienda",
  "FoodC_202408_SXSA_LasS": "Agrega tu número de celular para más ventajas",
  "FoodB_20260130_HkWX_ZAoO": "Escucha activa y comunicación adaptativa",
  "FoodB_I_Home_OrRo": "Inicio",
  "FoodB_0905__qppX": "{{number}} pedidos menos que antes",
  "FoodC_202408_GeGr_xwdt": "Comunicación más sencilla",
  "FoodB_comparison_FSKj_kcIf": "Los resultados de la comparación están en revisión",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodB_2_SApx_IEJM": "Dirección del titular de la cuenta bancaria",
  "FoodD_Name_December_Ykas": "Dic",
  "Gattaran_REGULAR_bTIM_MAXe": "El valor no puede ser mayor a 1000",
  "FoodC_202408_xwYJ_IzdZ": "Continuar",
  "FoodB_process_xsHa_ISXI": "Rectificada",
  "FoodB_wording_AKPa_CRKd": "Estado de la matrícula",
  "FoodB_0_Mail_SUKZ": "Correo electrónico",
  "FoodB_20260130_HASZ_Gzyp": "Resultados de la visita",
  "FoodD_Compliance_About_to_fTcV": "Vence pronto",
  "FoodB_calculator_VujK_GJbV": "Utilidad",
  "FoodB_calculator_mTaD_pjZv": "Descuento total",
  "FoodD_Name_June_sECU": "Jun",
  "FoodB_20260130_JGEK_zxII": "Adapta el discurso reconociendo la propuesta de valor de {{brand_name}} y los principales beneficios de la oferta comercial vigente",
  "FoodB_Show_Account_Type_vJvu": "Tipo de cuenta bancaria",
  "FoodB_signing_SqQL_FhYZ": "[{{incompletion_reason}}] Selecciona el tipo de tienda correcto",
  "FoodC_1_mnqk_AcOb": "No se pudo copiar",
  "FoodB_model20250116_dVSj_sFUN": "Esperando revisión",
  "FoodC_202408_ZOBi_xjfW": "Buscar nombre del edificio/departamento",
  "FoodC_supplement_Modify_Mobile_ZJkT": "Para modificar tu número de teléfono o tu contraseña, agregar una dirección de correo electrónico o eliminar tu cuenta,",
  "FoodC_address_gNYi_HdzX": "No se pudo guardar",
  "FoodD_supplement_Rules_RYAa": "Reglas",
  "FoodB_email_qCka_NBMf": "Hora preferida para contactar",
  "FoodB_tagging_You_chose_DSiT": "Seleccionaste “Cerró sus operaciones” como motivo para un socio potencial no válido. Debes proporcionar fotos o un número de teléfono de KP.",
  "FoodB_V1_DoLm_HYBb": "No comenzadas",
  "FoodB_0919__YKYU": "Sin promociones",
  "FoodB_calculator_mdtN_KpDW": "Descuento total",
  "FoodB_20260130_YoXd_Ofsz": "Documenta el estado de sus visitas correctamente y gestiona los resultados en Explorer, asegurándose de enviar los acuerdos establecidos al restaurante",
  "FoodB_V1_FPpu_unON": "Cargar menú físico",
  "FoodB_survey_zzNV_gkFf": "Notas",
  "FoodB_20260130_SwZo_Vtxu": "Calificación de la etapa: conversación comercial",
  "FoodD_up_DiDi_Delivery_FdmM": "DiDi Repartidor",
  "FoodB_1106_XQNm_orQN": "¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales?",
  "FoodC_202408_pSzr_CJqz": "Guardar dirección",
  "FoodB_0919__RZJo": "Pedidos completados",
  "FoodB_Fields_HLXT_aPou": "Foto del menú",
  "FoodB_Optimization_alYq_lLkr": "Foto de la entrada de la tienda del socio potencial",
  "FoodC_202412_JiED_bPrx": "Sin resultados. Ingresa una calle y número válidos.",
  "FoodB_20250414_EVlU_bloy": "Nuevos usuarios",
  "FoodC_web_Only_1_ZddK": "Sólo 1",
  "FoodC_1_ScPa_MVPN": "Copiado",
  "FoodB_202502_FEyX_TQNW": "Logotipo de la tienda",
  "Gattaran_REGULAR_ezuA_ZuBN": "Identificación fiscal",
  "soda-c-i18n---将赔付给您%s张免配送费券": "Obtienes %s cupón para un envío gratis.",
  "FoodC_all_You_haven_lSmt": "Aún no invitas a tus amigos. Intenta enviar una invitación.",
  "FoodB_calculator_rMFF_EMXI": "Efectivo",
  "FoodB_process_IUdd_MmbJ": "Apelación exitosa",
  "FoodB_improvement_iyXo_BbDz": "Residencia Permanente o Forma Migratoria Permanente (FM2)",
  "FoodB_1106_vAhW_qNLK": "Volver a grabar",
  "FoodD_accept_vrSy_OJYX": "Aceptación automática",
  "FoodB_Translation_IcyT_qdIf": "A rectificar",
  "FoodB_Optimization_topa_FKgX": "Teléfono del asesor",
  "FoodB_20250414_WmJY_oZbB": "Gráfico de embudo",
  "FoodD_Name_March_cqIc": "Mar",
  "FoodB_calculator_HfHr_bkLf": "Subsidio de DiDi sobre el descuento total",
  "FoodB_CO_MlOY_aPvr": "Cédula de ciudadanía",
  "FoodC_education__3_TDsa": "(3) Te negaste a recibir el pedido, ya sea una parte del mismo o por completo",
  "FoodB_B86_xkRX_bJPm": "¿Es precisa la información sobre las irregularidades?",
  "FoodB_1106_tTbZ_mKRW": "Análisis de IA",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "FoodC_education_2_If_SoSk": "2. Si un inconveniente relacionado con una entrega sucede porque el socio repartidor no siguió las recomendaciones, se podría considerar que fue responsabilidad del socio repartidor.",
  "FoodB_CL_Vista_Account_QcOm": "Cuenta Vista",
  "FoodC_education__unk_aOCD": "Recomendaciones de la aplicación sobre el tipo de entrega:  {{delivery_type}}",
  "FoodB_2_wbni_uePM": "Servicio",
  "FoodB_I_onwf_oaQH": "Ventas",
  "FoodB_process_keoD_znIy": "No se encontró ningún artículo coincidente",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "Si tu pedido llega %s minutos después del tiempo de entrega estimado,",
  "soda-c-i18n---取消订单": "Cancelar pedido",
  "请选择支付方式": "Selecciona un método de pago",
  "FoodB_calculator_UUgW_xBLd": "Cantidad de artículos",
  "小费": "Propina voluntaria",
  "Gattaran_V1__ccGl": "Últimos 30 días",
  "FoodB_end_OHsS_OQva": "Información básica",
  "FoodB_2_KsgR_YwjD": "Dirección del contribuyente (nacional)",
  "FoodB_Part1_Store_Name_jrHD": "Nombre del restaurante",
  "FoodB_progress_ZdQT_mHfK": "Restablecer",
  "sailing.crm-intl.普通": "General",
  "FoodB_calculator_Jryi_aded": "Personería fiscal",
  "FoodC_education__2_jwSo": "(2) Dejar en la puerta (con nota)",
  "FoodD_page_Manual_Accept_jCTW": "Aceptación manual",
  "FoodD_Optimization_ppct_mVEc": "Ingresa tu número",
  "FoodB_1106_EwXU_HfGg": "¿Qué trabajo se completó?",
  "FoodB_0_Please_upload_dcPG": "Carga una captura de pantalla del historial de mensajes de texto",
  "FoodB_Show_Subject_Information_RFOj": "Información del Representante Legal/Propietario",
  "FoodC_dish_Are_you_TaUN": "¿Salir de la página de la promoción?",
  "FoodB_20260130_XIop_NNlH": "Confirma que el DM comprendió los acuerdos y establece los pasos siguientes",
  "FoodB_CL_Add_any_egRn": "Es aceptable cualquiera de los siguientes tres documentos:\nPoder del Representante Legal\nCertificado de Comercio de Registro de Santiago (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_20250612_jtyZ_DrEC": "Amigo/familiar del propietario de la tienda",
  "FoodB_0920__QnBO": "Requisitos no cumplidos",
  "FoodB_0617_rPjX_pvuu": "¿El restaurante recibe pedidos por WhatsApp o teléfono?",
  "FoodB_resivion_Skip_qpSD": "Omitir",
  "FoodB_model20250116_IADF_eXfa": "Hora de salida",
  "FoodOpB_CRM_Card_holder_NfIL": "Ingresa el número de identificación del beneficiario",
  "FoodC_202412_aCvV_UNyj": "Agregar nueva dirección",
  "FoodB_20250414_qQjO_NTiY": "Línea de tiempo",
  "FoodB_Translation_CHLm_cImn": "Motivo de la apelación",
  "FoodB_email_Lqnd_eyfn": "Acuerdos y comentarios",
  "FoodB_0830__wEQD": "Pedidos completados en este mes",
  "FoodB_1106_OZBo_RTDB": "Intención del usuario",
  "FoodC_202410_SiDC_Empm": "Pedir",
  "FoodB_process_URNV_nSAi": "Aprobada",
  "FoodB_20260130_hhVl_koul": "Preparación estratégica",
  "FoodB_pt1_jkHO_eZrn": "Foto del menú o catálogo de la tienda",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodC_optimization_RLDn_cLAQ": "Agregar dirección de entrega",
  "FoodB_APP_QiyP_UysU": "ASP",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "¿Estaba sellado el empaque? (Obligatorio)",
  "FoodB_signing_zbyP_QIJp": "Asocia los socios potenciales duplicados",
  "分钟": "min",
  "FoodB_Show_Do_you_Tuop": "¿Dispositivo electrónico?",
  "FoodB_wording_oynB_JehX": "Cámara",
  "FoodB_202204_Online_Rate_EQQU": "Tasa de conexión",
  "FoodB_20260130_jmCn_dZjI": "El BD resuelve dudas con empatía, técnica y argumentos concretos. Invita al restaurante a dar el siguiente paso y siempre cierra con un acuerdo claro y concreto que permita avanzar",
  "FoodB_email_FvUP_tJQT": "Nombre",
  "FoodC_202412_SxTA_sqKU": "Ubicación cercana",
  "FoodC_popup_After_closing_ujoW": "Si sales, no se guardarán los platos seleccionados",
  "Gattaran_REGULAR_luKX_QwKw": "Entrada de impuesto de México",
  "FoodB_0905__ccXH": "Periodo del diagnóstico",
  "FoodB_01_Business_Properties_dFox": "Propiedades del negocio",
  "FoodC_remark_Enjoy_your_OvmD": "¡Que disfrutes tu comida!",
  "FoodB_task_KKOJ_hjRO": "Plantilla de conciliación",
  "FoodB_20260130_ZUfZ_dQmW": "Se apoya para dar su discurso en diferentes herramientas, tales como C-app, B-app y Explorer",
  "FoodB_20260130_LRgr_ZBuv": "Dominio de herramientas",
  "GDriver_trans_seconds_fFsz": "segundos",
  "FoodB_I_QuSz_HsAZ": "Descuento de promo %",
  "FoodB_Cardholder_CTNN_Zioe": "Apellido tit. tarj.",
  "FoodC_reasons_Enter_a_Pnzg": "Por favor, describe los detalles del problema.",
  "FoodB_audit_The_information_jxLV": "La información que enviaste no cumple con los requisitos",
  "FoodC_Notification_ZawA_BoKt": "Ver pedidos en curso",
  "FoodB_420241024_TFhQ_lSww": "Se rechazó correctamente",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Número de identificación de restaurante duplicado",
  "FoodB_V1_Yqgj_TuBe": "Vencidas",
  "FoodB_calculator_hmWL_DEwB": "No",
  "FoodC_20240607_IbZr_cIyA": "Por favor, revisa el enlace de la tienda y vuelve a intentarlo",
  "FoodB_order_ncPz_yPAH": "Entrega coordinada por la aplicación",
  "FoodB_0617_Bibj_VmDq": "Plataformas de la competencia",
  "FoodC_202412_Afcx_fMwc": "Seleccionar dirección",
  "FoodB_Upload_qSTm_LkAc": "Menú para consumo en el lugar",
  "FoodC_education__4_QYXm": "(4) Te negaste a pagar el pedido con pago en efectivo",
  "FoodB_APP_eiHc_XFQQ": "Porcentajes de promoción",
  "FoodB_V2_No_bank_plEI": "Faltan los datos bancarios",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "FoodB_1106_Ezht_DXlH": "El tamaño del archivo no puede ser mayor a 5 MB",
  "FoodB_20260130_JUUM_TDMw": "Oportunidades de mejora",
  "FoodC_education__3_ltNM": "(3) Otros factores que no puedas controlar y que causaron la cancelación del pedido, como que no se haya podido encontrar un socio repartidor que entregue el pedido o algún otro asunto.",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "FoodB_20260130_pTZf_mCnP": "Rara vez",
  "FoodB_V1_vKqg_VkFI": "Lista de proyectos",
  "FoodB_survey_CEvs_qbnA": "Porcentaje de tarifa de servicio del competidor – P",
  "FoodB_email_SHyg_fIzy": "Falta el correo electrónico. Por favor, agrégalo para enviar el correo electrónico",
  "FoodB_up20241218_ZADd_MrpU": "Por favor, selecciona entre uno y cinco artículos. No pueden seleccionarse artículos o bebidas con alcohol.",
  "FoodC_202412_enwa_nWfu": "Este artículo está agotado. Puedes explorar otros artículos de la tienda.",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de identificación del beneficiario",
  "FoodB_Contract_YYIE_YBzS": "Sí",
  "FoodB_V2_Failure_to_sQaD": "No cumple con los requisitos",
  "FoodC_edit_fOqC_upyr": "Encontrarse en la recepción",
  "FoodB_Show_Party_B_aVTH": "Información de la empresa/ persona física (propietario)",
  "FoodB_20250612_vHLr_wHDi": "Número de WhatsApp",
  "FoodB_Show_Tax_payment_Dbuz": "Forma de pago de impuestos (Local)",
  "FoodC_202410_KMCG_kJBn": "Cambiar",
  "FoodB_calculator_pQIn_LdhF": "¿La identificación fiscal es válida?",
  "FoodB_20260130_UEYG_BeRR": "Sentido de urgencia",
  "FoodB_Change_mgbD_xHZu": "Pedidos presenciales (diarios)",
  "FoodC_all_No_reward_ocGJ": "Sin premios",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodB_2_WRYW_FUbf": "Monto máximo permitido para una sola deducción",
  "FoodC_edit_KDUB_nVRR": "obligatorio",
  "FoodB_SOB_kyRS_ciCx": "Enlace al menú de Uber",
  "FoodB_Contract_adlR_lBNU": "¿Menú físico aprobado?",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nombre completo del contribuyente (Local)",
  "FoodB_communications_BCnM_evHy": "tiendas que tienen acciones a realizar esta semana para el impulso de tiendas nuevas",
  "FoodB_CO_hxPS_NoXd": "Permiso Protección Temporal (PPT)",
  "FoodB_20260130_rYlT_MdwI": "Otro",
  "Gattaran_visit_jnPQ_METw": "¿La persona que toma decisiones estuvo presente en la visita?",
  "FoodB_supplement_No_data_jUGB": "Sin datos",
  "FoodB_2_xyDg_hVfr": "Porcentaje de premio de tarifa de servicio de entrega de la tienda",
  "FoodB_Contract_fYLE_mfir": "Actualizar información de encuesta para la tienda",
  "soda-c-i18n---联系商家": "Comunícate con la tienda.",
  "FoodB_email_Zgsh_mNSy": "KP",
  "FoodB_optimization_Special_Meal_YtqD": "Artículos en promoción",
  "FoodB_V1_pmrO_ZtzK": "Completada",
  "FoodB_2_mmEx_SkyZ": "Tarifa de activación",
  "FoodC_edit_cKhP_xcTQ": "Encontrarse en la puerta de mi vivienda",
  "FoodC_20240607_hfCf_kdpO": "Teléfono",
  "FoodC_202410_FxEp_LCxL": "Procesando pago",
  "FoodB_task_UZKM_xysG": "Valor actual",
  "Groceries_web__Ovnh": "¡Lo sentimos! Por el momento sólo se puede acceder a las tiendas en la aplicación móvil.",
  "FoodC_edit_DOXu_EYnd": "Ejemplo: “llamar a la puerta, no tocar el timbre.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "FoodB_process_HvCv_QDks": "A rectificar",
  "FoodD_optimizatio_Tax_information_xHrV": "Información fiscal",
  "Gattaran_V1__SttS": "Promociones",
  "FoodB_202410_erZg_Bqks": "Entrega de la plataforma",
  "FoodB_1106_dhXS_LAAs": "Error de generación del resumen de IA",
  "FoodC_edit_stZr_IBeA": "Otro",
  "FoodC_edit_AxtX_PAiY": "Ejemplo: 1118, edificio C",
  "FoodB_20260130_uXlC_uqel": "Conversación comercial",
  "FoodB_0926__pZyK": "No hay promociones en curso",
  "FoodB_Show_ID_Card_BrxO": "Cédula de identidad",
  "FoodB_202402_sUzf_zwFG": "Nombre de la marca",
  "FoodB_Tracking_IRTU_sjuT": "Tipo de contrato",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ayer",
  "FoodB_030_zOTR_tsWu": "Mi zona",
  "FoodB_calculator_ULXU_HjOF": "IVA",
  "FoodB_manager_sgsH_EpiM": "día",
  "FoodB_1106_tybs_uREn": "Error de carga del archivo de audio",
  "FoodB_calculator_WKKD_DbHM": "Base gravable de pagos en línea",
  "FoodB_process_fSqQ_sYNN": "Ingresa el nombre del artículo",
  "FoodB_wording_ILbR_KjgC": "Tipo de persona",
  "FoodB_B86_qhmb_WAcC": "Debido a más de {{number1}} irregularidades en {{period}}, {{type}} ({{number2}}). El periodo de inactividad es {{time}}",
  "FoodD_Questionnaire_Finished_YvLk": "Listo",
  "FoodB_030_fqBt_uzDV": "Faltan permisos: {{City}}. Solicita un permiso en Gattaran.",
  "FoodB_0706_Supplementary_photos_UKYQ": "Agregar fotos",
  "FoodB_1106_Jvwt_cvqA": "Cargar archivo de audio",
  "FoodB_0617_BYzk_fNiR": "Hay un contrato de exclusividad con la competencia - R",
  "FoodB_202311_VkTS_OoIy": "Vencida",
  "FoodB_2_bYmN_VbtX": "Número de identificación fiscal",
  "FoodB_survey_eOXC_QSNG": "Demanda de crédito revolvente",
  "FoodB_2_dPdw_iWMi": "Archivos adjuntos",
  "soda-c-i18n---早间：%s-%s": "Durante la mañana: %s a %s",
  "FoodD_Orders_Can_not_fkHK": "La hora de inicio no puede ser posterior o igual a la hora de finalización.",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodB_data_Beginning_PbJC": "Hora de inicio",
  "FoodB_audit_Distance_between_BRSw": "Distancia entre la tienda anterior y la nueva",
  "FoodD_2_Income_Vqfp": "Ganancias",
  "FoodC_orderlist_Completed_Xuod": "Finalizado",
  "FoodB_B86_vHgx_eMOl": "Actuales",
  "FoodB_record_HWEd_dEzy": "Todo",
  "FoodB_0723_bRqb_EoqG": "Zona objetivo",
  "FoodC_notice_fOyQ_lqIn": "El pago en efectivo no está disponible. Por favor, revisa si el importe del pedido supera el límite, o si tienes otro pedido con pago en efectivo en curso, e inténtalo de nuevo más tarde.",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_0617_bADA_vnGU": "Servicio de pedidos autogestionados",
  "FoodB_madero_Store_Delivery_JbdX": "Entrega propia de la tienda",
  "FoodB_210811_No_tax_QkcN": "Falta un documento fiscal",
  "FoodB_2_WbzT_odyB": "Información de pago",
  "FoodB_Optimization_tkDQ_NljT": "Coordenadas de la tienda",
  "FoodB_1106_ZAuG_REFT": "¿Confirmas que deseas cerrar y salir? La grabación se detendrá y tu contenido no se guardará.",
  "FoodB_1106_BLKp_thZN": "Información de seguimiento",
  "FoodC_20240607_wfRH_rTAa": "Información de la tienda",
  "FoodB_1106_foqL_RTHY": "Describe el siguiente contenido grabando con la voz, subiendo audio o ingresando texto:",
  "FoodC_202412_nXPk_kwtQ": "¿No encuentras la dirección? Prueba otras palabras",
  "FoodB_calculator_HXix_qhAK": "ISR sobre base gravable",
  "FoodB_1106_AyGO_yZLr": "Asegúrate de que tu conexión de red es estable y toca \"Analizar de nuevo\". Volveremos a generar el resumen de IA.",
  "FoodB_2_pQiY_xzxv": "Proporción de la deducción",
  "FoodC_202408_reKH_lclj": "Agregar dirección de entrega",
  "FoodC_edit_hDGv_arOT": "Encontrarse en la recepción de abajo",
  "FoodB_420241024_mWia_Agjc": "No se logró",
  "FoodC_education__1_mJTG": "(1) Si la tienda ya confirmó y aceptó el pedido, puedes usar la función \"Cancelar pedido\" o contactar a la tienda y pedirle que cancele el pedido. Si la tienda no acepta cancelar el pedido porque ya está listo o por otro motivo razonable, no podrás cancelar el pedido sin costo extra. Si insistes en cancelar o te niegas a recibir una parte del pedido o el pedido completo, se deberán pagar los gastos correspondientes de ese pedido.",
  "FoodB_phrase__PWcd": "No hay promos finalizadas para ver",
  "FoodB_APP_jedo_DJtn": "Situación de la promoción",
  "FoodB_improvement_sBdi_DQvl": "Residencia Temporal o Forma Migratoria Temporal (FM3)",
  "Gattaran_V1__hUDQ": "Servicio",
  "FoodB_0_Please_upload_BZIQ": "Carga una captura de pantalla del historial de chat",
  "FoodB_Show_Current_NJqK": "Cuenta corriente",
  "FoodB_1106_bquQ_ajOd": "Entrada de texto",
  "FoodB_CL_power_of_KgHH": "Contrato de mandato",
  "FoodB_2_CIUw_hBMd": "Contacto principal de la empresa/propietario",
  "FoodC_edit_iuIV_BOva": "10 minutos",
  "FoodB_Optimization_cplR_qAqv": "Compatible",
  "FoodB_email_wMIf_SGNM": "Nombre del contacto",
  "FoodB_list_KP_Phone_qQCQ": "Teléfono del representante de la tienda",
  "FoodC_replace_Clear_Filter_iwTY": "Borrar filtros",
  "FoodB_030_SQUQ_YDRS": "No mis tiendas",
  "FoodB_Contract_wsvf_fSJn": "Regla de Paridad de Precio",
  "FoodB_V2_dLkl_pbiF": "Para realizar esta acción, actualiza la aplicación a la versión más reciente.",
  "FoodB_governance_OCvE_wAPt": "Gestionar ahora",
  "FoodB_Translation_JSTh_Vrzb": "Motivo detallado de la apelación",
  "FoodB_1106_QRoy_iWHx": "Iniciar grabación",
  "FoodB_model20250116_innF_fIuu": "Visita exitosa",
  "FoodB_CO_yweP_bWhk": "Pasaporte",
  "FoodC_202408_ksyj_sXlp": "Acerca de la tienda",
  "FoodB_0622_Increase_store_kZfr": "Agregar comparación de tiendas",
  "FoodB_calculator_GdDU_bFgc": "Subsidio DiDi",
  "FoodC_202412_dCuL_VUFU": "Actual.",
  "FoodOpB_CRM_Party_B_BCQp": "Número de identificación de la empresa",
  "Gattaran_REGULAR_XlOa_yzqB": "Resultado",
  "FoodB_calculator_BKfQ_ehtA": "Comisión DiDi",
  "FoodC_202412_bolI_YXBT": "Direcciones guardadas",
  "FoodB_email_SdUD_YAhg": "Falta información. Por favor, agrégala para enviar el correo electrónico",
  "FoodB_1106_XrIH_sjvu": "Lo sentimos, se produjo un error en el análisis de tu grabación que hizo la IA.",
  "FoodB_0617_qTmE_PWeM": "¿Cuántos pedidos con retiro en tienda realiza el restaurante por día?",
  "FoodB_process_vjLl_iVPp": "Rechazada",
  "FoodB_B86_Bhsy_ekdS": "Gestión de irregularidades",
  "FoodB_optimization_PAD_Status_ipTp": "Estado de la tableta",
  "FoodD_Storefront_YFcS_cnUy": "DiDi Negocio",
  "FoodB_verification_Amount_BBjJ": "Monto",
  "FoodC_20240607_Upph_ldoj": "Recordatorio de compra",
  "FoodB_calculator_VKAb_KHst": "Subsidio DiDi",
  "FoodD_Name_May_zYiz": "May",
  "FoodB_list_KP_Name_GQRs": "Nombre del representante de la tienda",
  "FoodC_202412_Oant_EESB": "Siguiente",
  "FoodB_CO_ksMa_ymXB": "Persona jurídica",
  "FoodB_communications_APfO_DcRl": "Acciones no completadas para el impulso de tiendas nuevas",
  "FoodC_edit_JdIz_uKvw": "Encontrarse afuera",
  "FoodC_education_In_order_SRIb": "Esta política de cancelación se creó para ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}.",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento tributario (local)",
  "FoodB_method_hwZM_aUnb": "Descargar Explorer",
  "FoodB_management_Automatic_closing_xRSd": "Cierre automático de la tienda",
  "FoodC_202408_LBac_RLgP": "Agrega la dirección de entrega para que el socio repartidor pueda entregar el pedido",
  "FoodB_2_RroD_vqJk": "Banco emisor de la cuenta",
  "FoodC_202408_RRtT_ZjIG": "Agregar dirección de entrega",
  "FoodC_20240607_hhNB_mCBD": "Número de teléfono celular",
  "FoodB_email_QTTk_ZllR": "Enviar acuerdos a la marca",
  "FoodB_20231012_GZve_uPZM": "Ya se establecieron las reglas de cálculo de la fecha límite para este tipo de tarea. Por favor, no vuelvas a ingresarlas.",
  "FoodB_2_WdmF_TVYJ": "Tipo de signatario",
  "FoodB_202410_piGe_Vcqi": "Foto de portada",
  "FoodB_diagnosis_Items_qQOR": "artículo(s)",
  "FoodC_202408_BsWi_bWTi": "Editar dirección",
  "FoodB_1106_hYOE_wfgV": "Vista previa de resultado de reconocimiento",
  "FoodC_202408_LtuD_oTxz": "Cancelar",
  "FoodB_V1_hqNE_fQDz": "proyectos",
  "FoodC_sales_If_the_TsPm": "Para ayudarnos a verificar el problema con la tienda y el socio repartidor, por favor dinos si el pedido fue entregado en un empaque resellable o sellado de alguna otra forma (como con grapas).",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} días",
  "FoodB_2_During_the_QHhU": "Periodo de registro",
  "FoodB_field_No_need_hToz": "Opcional",
  "FoodB_2__YqWB": "Motivo del rechazo",
  "FoodB_APP_rwZD_SFlh": "B2C + P2C burn / GMV",
  "FoodB_2_UZQT_LsHI": "Tarifa de Servicio mínima por uso de la app, para la entrega coordinada mediante repartidor registrado en la plataforma",
  "FoodC_edit_Fyzp_tERt": "El usuario repartidor te contactará cuando llegue al punto de entrega y esperará en el lugar acordado por máximo {{time}}. Por favor, ten tu teléfono a la mano.",
  "FoodB_process_WMCl_eXXl": "En apelación",
  "FoodC_education__2_uVUK": "(2) La tienda a la que le hiciste el pedido estaba cerrada, un producto estaba agotado, ocurrió un accidente o la tienda o el socio repartidor cancelaron el pedido por otro motivo. En ese caso, recibirás un reembolso completo.",
  "FoodB_V1_VKlO_UPTE": "Descripción del proyecto",
  "FoodB_orders_Select_Store_gtmG": "Seleccionar tiendas",
  "FoodB_2_btuN_DvIR": "Información del dispositivo",
  "FoodB_audit_Suspected_duplicate_ntLx": "Posible tienda duplicada",
  "FoodB_signing_ufaV_OVfS": "[{{incompletion_reason}}] Asocia los socios potenciales duplicados",
  "FoodB_20260130_zsJf_PMwY": "No aplica",
  "FoodB_requirement_uBiP_YocR": "Porcentaje de pedidos no preparados a tiempo",
  "FoodB_20260130_sqnQ_jioF": "Dominio del producto y oferta comercial",
  "FoodB_calculator_CcKA_weRh": "Para propósitos referenciales únicamente: el pago final a las tiendas estará sujeto a deducciones por cancelaciones, temas de posventa y otros motivos.",
  "FoodC_202408_qGSr_IQoW": "Editar",
  "FoodB_APP_mDID_tHft": "Seleccionar periodo de datos",
  "FoodB_GTR_Eiwe_KevC": "Nombre del asesor",
  "FoodB_incomplete_hmSA_mNRv": "Marcar como No completado",
  "FoodB_Optimization_LfPz_zDPq": "Completar registro",
  "FoodB_20260130_BVCG_uZQW": "Fórmula = (Puntaje del evento 1 / 5 + Puntaje del evento 2 / 5 +…) / Cantidad de eventos válidos * 100%",
  "soda-c-i18n---提交申请": "Solicitar cancelación",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento tributario (nacional)",
  "FoodB_Contract_yBjK_Ngdm": "¿Exclusividad contratada?",
  "FoodB_1106_zLsQ_PVUN": "Método de seguimiento",
  "FoodB_1106_UWHB_lYiW": "Transcripción de grabación",
  "FoodB_Optimization_WHZp_mzcX": "Número de teléfono de la tienda",
  "FoodB_1106_oEsa_BYuK": "¿Cuáles son los próximos pasos?",
  "FoodB_1106_dvab_aMNJ": "Enviar",
  "FoodC_202408_cjXm_VVcd": "Si sales, no podrás ver tu pedido",
  "Gattaran_visit_hZGE_sfuk": "Retroalimentación general",
  "FoodB_improvement_xKix_HPpN": "Identificación del tercero beneficiario (requerido en algunos casos, ver en parte inferior.)",
  "FoodB_202410_Cahy_pzlN": "Información básica",
  "FoodB_2503_JeQk_FWxd": "Cargando...",
  "FoodB_optimization_Buy_gifts_daUI": "Compra X, llévate Y gratis",
  "FoodB_2_dfjc_UyDL": "Monto",
  "sailing.crm-intl.乙方联系方式": "Teléfono Celular",
  "FoodB_Show_Delivery_and_UBbK": "Distribución y tarifas de servicio",
  "FoodC_update_The_expected_ZzFg": "El tiempo de entrega estimado se basa en el tiempo de entrega más reciente.",
  "FoodB_pt1_ofEk_bcpz": "Correo electrónico de la persona de contacto",
  "FoodC_202408_BTvL_umes": "¿Deseas salir?",
  "FoodB_B86_lRNJ_EMZv": "Sí",
  "Gattaran_visit_nNId_fOhX": "La visita del BD fue efectiva",
  "Gattaran_REGULAR_irYR_Bntt": "Si no estás seguro de si tu número de identificación fiscal es válido, cópialo y compruébalo en el sitio web oficial que se indica a continuación:",
  "FoodC_202408_ReqK_LVas": "Confirmar",
  "FoodB_Contract_tvcI_RNvn": "Carga correcta del menú para comer en el lugar aprobado",
  "FoodC_revision_Less_meal_pHwq": "Error en pedido",
  "FoodB_model20250116_HPUj_zcce": "No se encontró la ubicación. No es posible marcar la hora de ingreso o salida. Por favor, activa los servicios de ubicación en la configuración del teléfono y permite que la aplicación de BD acceda a ellos.",
  "FoodB_420241024_rQXh_ONDO": "Se logró",
  "FoodB_system_Competition_NFPY": "Competidor",
  "FoodB_2_JpQk_PLSh": "Información del representante legal",
  "FoodB_task_HEvc_Emme": "Se ejecutó/ejecutaron {{X}} tarea(s) durante esta visita",
  "FoodB_20260130_kPaF_pdwu": "Casi nunca",
  "FoodB_signing_coyr_QLiQ": "Cada imagen/archivo puede pesar hasta 10 MB, y puedes subir hasta 8 imágenes/archivos",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "FoodB_1106_uIrJ_FVVL": "¿Cuáles son las actualizaciones clave, las necesidades de los usuarios o los problemas esenciales?",
  "Gattaran_visit_kYQA_ZYsK": "El BD maneja bien las objeciones de la tienda",
  "FoodB_20260130_WiZC_rYRd": "Nunca",
  "FoodB_communications_UOIk_QdZg": "Realiza las acciones para el impulso de tiendas nuevas para obtener ventajas adicionales. Las acciones vencen en {{task_left_days}} día(s)",
  "FoodB_process_hZyR_OxLH": "Copiar enlace de la tienda {{name}}",
  "FoodB_2_mfKY_fvJg": "Entrega de la tienda",
  "FoodB_B86_AADM_isyE": "Cancelar",
  "FoodB_Show_Delivery_commission_mVxE": "Porcentaje de la tarifa de servicio de entrega directa por la tienda (%)",
  "FoodC_education__1_qvVC": "(1) No recibiste el pedido a tiempo",
  "FoodB_Fields_CnCd_RzYS": "En revisión",
  "FoodB_optimization_Needs_IovK": "Obligatorio",
  "FoodC_method_Wait_keAM": "Esperar",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "Por favor, envíanos tus comentarios y ayúdanos a mejorar.",
  "FoodB_calculator_RWNx_Xkrf": "Persona física",
  "FoodB_boarding_Name_of_QuHz": "Nombre del titular de la tarjeta",
  "FoodB_CL_Simple_company_JBRG": "Sociedad de sistema simplificado",
  "FoodC_edit_bxpb_udFq": "Ejemplo: Edificio C, Núm. 21, Cl. 185 #45-03, Suba, Bogotá, Cundinamarca, Colombia",
  "FoodB_IV_Open_shop_xlhI": "Apertura automática de la tienda",
  "Gattaran_visit_xnVQ_bENu": "Objetivos a mejorar",
  "FoodB_2_IJZE_PnUS": "¿Tienes disponible el método de recolección personal?",
  "FoodB_20260130_VCAk_tRtc": "Mejorar la preparación y estrategia de visita",
  "FoodB_1106_eUGB_DZjs": "Actualizaciones clave",
  "FoodB_process_nXaG_aweQ": "Detalles de la coincidencia",
  "FoodB_1106_oWun_aWqC": "No hay actualizaciones claves en este momento",
  "FoodB_0905__pNYF": "Los pedidos se superponen. La suma no refleja el total de pedidos completados cada día.",
  "FoodB_1106_SvnP_rxzP": "Listo",
  "FoodB_0622_Store_management_ztNB": "Operaciones de la tienda",
  "FoodC_202408_XlDL_LjiM": "Entendido",
  "FoodB_20250612_WpCB_xKZJ": "Otros",
  "FoodB_202402_TFYh_dasm": "Otros",
  "FoodB_optimization_Business_Properties_tURJ": "Propiedades de la tienda",
  "FoodB_0623_Store_GZFE": "Tienda",
  "Gattaran_V1__zewR": "Menú",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food | DiDi Repartidor. Disfruta tu comida cuando quieras, donde quieras.",
  "FoodC_edit_dECN_fkIy": "Encontrarse fuera del edificio de oficinas",
  "FoodC_202408_tJIe_WbFo": "Cancelar",
  "FoodB_2__CkLu": "La misma ciudad",
  "FoodC_202408_tlOV_uOmJ": "Agrega tu número de celular y obtén promociones en tus pedidos",
  "FoodB_1106_grLB_GkRM": "Si cierras la página durante la carga, no se guardará el resultado actual.",
  "FoodB_communications_hhCR_kEAh": "tiendas que tienen acciones a realizar esta semana",
  "FoodB_resivion_Inaccurate_information_dmRA": "¿Hay alguna información incorrecta?",
  "FoodB_field_Needs_IbzB": "Obligatorio",
  "FoodC_page__KWIm": "Aceptar",
  "FoodB_20260130_eQWh_Vvub": "Optimizar el manejo de la agenda y la ruta",
  "FoodB_1106_ACTr_mhVt": "Confirmar",
  "FoodB_subsidy_tVNZ_GHKr": "Recordatorio",
  "FoodB_0905__Uuug": "Reglas del diagnóstico",
  "FoodC_sidebar_Update_successfully_cuyI": "Actualización completada",
  "FoodB_list_Business_Category_uDdS": "Categoría de ventas/negocio",
  "FoodB_survey_yEPf_ujZP": "Pedidos completados por día con la competencia - P",
  "FoodB_process_eAKS_LYXf": "Rechazada",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de asignación automática",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "El primer dígito debe ser 1 y se deben ingresar 11 dígitos.",
  "FoodB_Translation_nqGe_fLuf": "Nombre del firmante",
  "FoodB_2_YHve_IWkP": "Material de entrega",
  "FoodB_comparison_dRXO_qebt": "Ajustar precio",
  "FoodB_1106_jqDc_LmDv": "No se pudo cargar la grabación. Por favor, asegúrate de que tu red sea estable e intenta grabar de nuevo.",
  "FoodC_20240607_RSyh_XJnN": "Por favor, abre el enlace en tu dispositivo móvil",
  "Groceries_1_MhVY_Etfm": "Artículo cambiado",
  "FoodB_CO_VOrd_PUvD": "Tipo de identificación",
  "FoodB_Show_Provisional_Tax_xJRc": "Provisional",
  "FoodB_20260130_gEaG_lLwE": "Resolución de acuerdos y objeciones",
  "FoodB_process_jvuI_tPXa": "Elegir artículo principal",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "FoodB_20260130_xZuv_HObe": "Reforzar las habilidades de negociación",
  "FoodB_202402_RxAj_UFpT": "Personal",
  "FoodB_V1_toMO_YDdz": "Tareas regulares",
  "FoodB_up20241218_VRuL_OZqJ": "Registro previo de la promo",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodB_audit_The_strings_NPFx": "Hacer clic en confirmar iniciará el proceso de revisión \"{{strings}}\". No se puede solicitar la firma del contrato hasta completada la revisión. ¿Deseas continuar?",
  "FoodC_1_dXUH_ThDd": "Ver más",
  "FoodB_model20250116_GjAr_XZPC": "Hora de ingreso",
  "FoodB_APP_WsXR_yQpy": "Inversiones",
  "FoodB_20260130_Czox_PUeI": "Manejo de objeciones y comunicación",
  "FoodB_ads_yERH_XMYy": "¿Se ha registrado correctamente el anuncio promocional?",
  "FoodC_20240607_wWhy_deWR": "Por favor, actualiza la página y vuelve a intentarlo",
  "FoodB_governance_ireV_yxHO": "Fecha límite de la tarea",
  "FoodB_Show_Settlement_Information_rcRc": "Información de Pago",
  "FoodB_2_TDdO_bwkd": "Foto del Contrato",
  "FoodB_1106_kpYX_BXVq": "Analizar",
  "FoodC_edit_oOAR_FExH": "Oficinas",
  "Gattaran_resivion_More_KTYU": "Más",
  "FoodC_202412_MrwA_fRUi": "En este momento, la tienda está cerrada. Por favor, regresa más tarde.",
  "FoodB_0707_Lifted_off_tnXl": "No disponible",
  "FoodB_2_cAcO_mtpN": "Nombre del titular de la cuenta bancaria",
  "FoodB_email_qdfP_heFs": "¡Hola! Visitamos tu tienda {{store_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodB_2_zmyu_iOSq": "Porcentaje de premio de tarifa de servicio de entrega de la plataforma",
  "FoodC_switch_TFwP_lxTd": "Propina predeterminada",
  "FoodB_0113_ZcCF_NbjE": "Puedes agregar un plan de visita aquí",
  "FoodB_store_TYrz_xUSp": "ID de la tienda",
  "FoodB_tasktoteams_aXrr_bgrl": "Pedidos diarios completados (servicio de pedidos propio)",
  "FoodB_0905__uatF": "Mayor que {{number_or_rate}} tiendas cercanas",
  "FoodB_20260130_KYcL_KXQE": "Casi siempre",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodC_202408_ajMC_lsta": "Tienda cerrada",
  "FoodB_audit_Review_Opportunity_ZQHk": "Revisión de la información básica del socio potencial editada",
  "FoodB_Display_ohOC_SIAy": "Información de contacto",
  "FoodB_Contract_ZLgE_qHzf": "Competitor price comparison in the agreement",
  "FoodC_edit_wBJW_yfSo": "Apartamento",
  "FoodC_202408_RTrU_hOhN": "Por favor, activa los permisos de ubicación. Para hacerlo, ve a la configuración del sistema, selecciona la aplicación y activa los permisos de ubicación correspondientes.",
  "FoodB_audit_Click_OK_Zfsf": "Si das en confirmar, se activará el",
  "FoodC_20240607_aOOB_RMKm": "Pago en efectivo no disponible temporalmente",
  "FoodB_20250414_QcoH_HIDg": "Total de usuarios",
  "FoodC_page__iyoe": "Ver menos",
  "FoodB_1106_PVUq_gUVg": "Entrada de voz",
  "FoodB_0905__kaPI": "Calificación del diagnóstico",
  "FoodB_part3_DIXA_purA": "Estado de cuenta",
  "FoodB_20260130_FbBo_MxTb": "El BD investigó previamente la situación actual de sus Rs a visitar (competencia, métricas, precios, etc.)",
  "FoodB_ads_WAjG_IoqX": "Anuncio",
  "soda-c-i18n---将赔付给您1张%s折扣券": "Obtienes un cupón del %s de descuento.",
  "FoodB_0622_Sales_KRCg": "Volumen de ventas",
  "soda-c-i18n---送您%s张免配送费券；": "Te daremos %s cupón para un envío gratis.",
  "FoodB_supplement_Network_connection_RVcl": "Falló la conexión. Comprueba tu configuración de red.",
  "FoodB_0617_lXTk_DfVL": "Fecha de vencimiento del contrato de exclusividad con la competencia - R",
  "FoodB_tagging_You_chose_tIKm": "Invalidación solicitada por: \"Tienda inexistente\". Este proceso requiere estar a una distancia de {{distance}} del punto. Favor de verificar e intentar de nuevo.",
  "FoodB_20250612_nsLy_sirO": "Debes ingresar entre ocho y nueve dígitos",
  "FoodB_Fields_xUKf_huqZ": "Nombre de la tienda",
  "FoodB_subsidy_xslH_mDaQ": "Este Acuerdo complementario para el premio de tarifa de servicio se firmará bajo el nombre de esta tienda. Actualmente, hay varias tiendas que ya han firmado bajo este nombre y que también recibirán premios de tarifa de servicio adicionales. ¿Quieres continuar con la firma?",
  "FoodB_task_idjV_gpOC": "Tarea ejecutada",
  "FoodC_202412_PwIG_QPFY": "Ingresa una dirección",
  "FoodC_20240607_eLRx_hJRj": "Página no disponible en computadoras",
  "FoodB_item_qIfj_VfVa": "Información básica",
  "FoodB_20260130_TlfO_izWQ": "Realiza preguntas abiertas para conocer la actualidad del restaurante, escuchando e identificando sus necesidades",
  "FoodB_20260130_HUuq_fjkk": "Sin calificación",
  "FoodC_edit_Hxmm_vrkU": "Edificio residencial",
  "FoodC_202408_PJcq_SjqG": "¡Ups! No hay información de contacto para esta tienda",
  "FoodB_tasktoteams_FSIB_Lmdl": "Enlace al menú de {{Rappi}}",
  "FoodB_20260130_XEUl_vhGH": "Gestión del tiempo",
  "FoodB_communications_ZlRD_aGjm": "día(s) faltante(s)",
  "FoodB_infomation_braW_sRbm": "Tipo",
  "FoodB_0322_gUpY_CIHG": "No hay tiendas que coincidan con los filtros",
  "FoodB_Show_Companies_Limited_xsLB": "Personas Jurídica - Sociedad Anónima",
  "FoodB_20260130_dkze_tLMR": "El BD tiene claros los objetivos de las visitas asociadas",
  "FoodB_list_Apply_for_RxQn": "Solicitar firma",
  "FoodB_field_Is_you_uNye": "¿Sujeto al pago del IVA nacional?",
  "soda-c-i18n---延迟送达%s分钟以上": "Demora mayor a %s minutos",
  "FoodB_0617_UUYe_lgPA": "Porcentaje de tarifa de servicio de la competencia - R",
  "FoodB_0617_JNlE_tpzR": "Porcentaje de tarifa de servicio de la competencia - U",
  "FoodB_calculator_hPAw_BZlP": "Impuesto cedular",
  "FoodB_leads_The_relationship_jkYA": "Hora ideal para contactar",
  "FoodB_Tracking_VElw_nkCE": "Versión del contrato",
  "FoodB_20260130_gMyi_nxVp": "Cierre efectivo",
  "FoodB_2_cggC_JRRZ": "Foto de la identificación",
  "FoodB_process_tlsV_pFnp": "Confirmar coincidencia",
  "FoodC_homepage_Search_for_CiMZ": "Buscar comida",
  "FoodB_task_ROBF_tTxm": "Categoría de ventas/negocio",
  "FoodB_model20250116_wlQy_yyEp": "Hora de la visita",
  "FoodB_Fields_ecRi_VRjb": "Foto de la entrada de la tienda",
  "FoodD_suspensionpage_In_the_zGEU": "No hay más resultados",
  "FoodC_202408_AFKG_hWIj": "Fuera de rango. Favor de cambiar la dirección",
  "FoodB_page_Ejhz_BIgP": "Registrarse",
  "FoodB_signing_UrJI_UWgi": "Quitar marca",
  "FoodB_202410_XLby_OmOV": "Dirección de la tienda",
  "FoodB_20260130_YWCI_RTgg": "Mejorar en cierres efectivos",
  "FoodB_b_Source_of_qGPd": "Origen del evento",
  "FoodB_0_Please_upload_roTo": "Carga una captura de pantalla del historial de correo electrónico",
  "FoodB_2_uPrf_VINK": "Nombre del propietario de la empresa (persona natural)",
  "FoodC_perception_Tip_exceeds_VSFf": "La propina supera el límite",
  "FoodB_governance_Kygz_iFAW": "¿Rectificación completada por violación de paridad de precio (sin precio igual al local)?",
  "FoodB_email_NJBQ_LwUX": "Este contacto no tiene un correo electrónico registrado, por lo que no se le pueden enviar este tipo de mensajes. Por favor, agrega un correo electrónico y vuelve a seleccionarlo.",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfecha con la situación actual",
  "FoodB_202202_Minutes_tWiN": "min",
  "FoodB_Translation_vrHE_fstW": "Rectificado",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagos",
  "FoodC_education_Principles_of_RKEk": "Recomendaciones en caso de algún inconveniente con la entrega",
  "FoodB_signing_DEdQ_xyXM": "Subir archivos",
  "FoodB_group0901_KjSA_JaMq": "Obligatorio",
  "FoodB_email_AhaC_FOft": "Otro contacto",
  "Gattaran_visit_Zykg_WdpB": "El BD preparó la visita",
  "FoodB_store_uzIT_yKqJ": "Nombre de la marca",
  "FoodB_2_Vbaq_cSPK": "Cargo del contacto del principal de la empresa/propietario",
  "FoodB_20260130_Fokt_VXiq": "Enfoque a los resultados y proactividad",
  "FoodB_requirement_aAaC_nmQK": "Horas pico en línea",
  "FoodB_up20241218_WbCj_pCMp": "Registro previo para la promoción de artículos en promoción de tienda nueva",
  "FoodB_20260130_HZgt_YVcN": "Fórmula = (Calificación de la preparación estratégica + Calificación de la conversación comercial + Calificación de los resultados de la visita) / 3 * 100%",
  "FoodB_tagging_You_chose_lWSH": "Invalidación solicitada por: \"No es un local comercial\". Se requiere estar a menos de {{distance}} del lugar para validar. Favor de verificar e intentar de nuevo.",
  "FoodB_pt1_KFvg_Iavt": "Cédula o NIT",
  "FoodB_1106_UjEj_dsYG": "Cancelar",
  "FoodB_0617_tikP_Dusl": "Encuesta para la tienda",
  "FoodB_process_PFDy_CuVh": "En revisión",
  "FoodB_20250612_ehqr_pgKz": "Gerente de tienda",
  "FoodB_model20250116_PRsL_yJEl": "Por favor, elige al menos {{num_required_fields}}",
  "FoodB_20260130_iMSl_cUof": "Manejo de sus KPI y relacionamiento de las métricas del R",
  "FoodB_CL_Store_Subject_RHFT": "Tipo de signatario",
  "FoodC_MVP_ASpO_MFfF": "Detalles del pedido",
  "FoodB_Translation_mIfp_fymE": "Resolver",
  "FoodB_process_fmOQ_ZlAg": "No se encontró ningún artículo",
  "FoodB_calculator_QGtY_JOsw": "Inversión de la tienda sobre el descuento total",
  "FoodC_details_Refund_Details_sGIk": "Detalles del reembolso",
  "FoodB_250430_GwJd_SQQB": "Nivel de la tienda",
  "FoodB_Translation_IfKE_iqmc": "Rectificación fallida",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Dirección del  contribuyente (Local)",
  "FoodC_education_Basic_requirements_hIbv": "Recomendaciones para los usuarios con respecto a la entrega",
  "支付方式": "Payment Method",
  "FoodB_Bill_nfFF_FDip": "Tarifa de entrega de la tienda",
  "FoodB_20260130_GcFe_YDVN": "Plan de acción",
  "FoodB_APP_wyiJ_mGlw": "Mes de inicio",
  "FoodB_20250414_faym_bhsa": "Coinversión de la plataforma",
  "FoodB_Launch_Illegal_import_jlOS": "Entrada no válida",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "FoodB_calculator_tLev_cAgO": "Pago en línea",
  "FoodB_new1_Name_similarity_gepH": "Similitud del nombre",
  "FoodB_store_epqq_hvJb": "Nombre de la tienda",
  "FoodB_1106_ocKT_vZHR": "La grabación no puede superar los 2 minutos",
  "FoodB_20260130_WkaF_rdke": "Si la puntuación de un módulo es “Sin calificación”, entonces dicho módulo no se incluye en la calificación total",
  "FoodB_20260130_eosk_tYnU": "Visitas efectivas {{effective_visit_percentage}}, visitas no efectivas {{ineffective_visit_percentage}}",
  "FoodC_202408_sbmp_YFyl": "Ubicación actual",
  "FoodB_Wordings_MYHl_FXti": "Selecciona un motivo",
  "FoodB_Show_Not_applicable_jXBz": "No aplica",
  "FoodD_Incentive_In_progress_GNvs": "En curso",
  "FoodB_Optimization_xyJu_XgOc": "Por favor, ingresa 10 dígitos",
  "FoodB_2_Visit_Records_LiJy": "Resumen de visitas",
  "FoodC_edit_fLUx_wHAP": "Ejemplo: “llevo una camisa estampada.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "FoodD_problem_I_see_NhGG": "Aceptar",
  "FoodB_optimization_Contract_No_GvBj": "Núm. de ident. del contrato",
  "FoodB_list_Online_Inspection_rExT": "Inspección de la tienda",
  "FoodB_APP_sdNU_DaTX": "Inversiones y promociones",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "FoodC_202408_KYqe_yVZD": "Ahora no",
  "FoodB_250430_kaeY_cgas": "Nivel de visita",
  "FoodC_edit_kzdk_yzVc": "Encontrarse en la puerta de mi habitación",
  "FoodB_switch_yJQj_DSir": "Participando en promociones 100% financiadas",
  "FoodB_Show_Colombia_ID_igRe": "Cédula de ciudadanía",
  "FoodC_sales_Supplementary_information_ihyk": "Detalles adicionales",
  "FoodB_survey_IegO_JQod": "Demanda de tarjeta de crédito",
  "FoodB_2_Planned_bPON": "Plan",
  "FoodB_2_fGxM_YHeU": "Vigencia del beneficio de descuento en la Tarifa de Servicio",
  "FoodB_1106_jWEH_dYMs": "Volver a analizar",
  "FoodC_edit_HEFc_Dppo": "Encontrarse fuera de mi edificio residencial",
  "FoodB_Wordings_iyFv_fDmW": "Comentarios adicionales",
  "FoodB_store_Order_Coupon_zpSY": "Cupón de reembolso de pedido",
  "FoodB_APP_RDdB_KQgY": "Filtrar promociones de ventas",
  "FoodC_education_In_the_nIgD": "La cancelación se considerará responsabilidad tuya en las siguientes situaciones:",
  "FoodB_1106_fIyR_ECeB": "Ingresa contenido",
  "FoodB_Show_Companies_Limited_hFAJ": "Personas Jurídica - Sociedad de Responsabilidad Limitada",
  "Gattaran_visit_opSF_XPmM": "El BD trae objetivos claros a la visita",
  "FoodC_202412_SJdc_Bwta": "¿No es una ubicación cercana? Toca el botón de la derecha para actualizar tu ubicación.",
  "FoodC_dish_New_guest_bkGC": "Para primer pedido",
  "FoodC_202408_WiRK_SITI": "Agregar dirección",
  "FoodB_calculator_Vzvw_WmgN": "Método de pago",
  "FoodC_202408_IDjR_CbbT": "Aceptar",
  "FoodB_GTR_rBBn_RmKL": "Estándar",
  "FoodC_education__2_KHhl": "(2) Si no llegaste al lugar de la entrega para la hora especificada o si ingresaste la dirección o número de teléfono incorrectos, te negaste a aceptar una llamada del socio repartidor o te negaste a recibir parte del pedido o el pedido completo sin un motivo válido, se deberá pagar el pedido.",
  "FoodB_2_Call_visit_NGFu": "Teléfono",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodB_calculator_giVW_AULQ": "Precio unitario de la plataforma",
  "FoodC_education_If_you_RTIV": "Si pagaste un pedido y necesitas cancelarlo, se aplicará lo siguiente:",
  "FoodC_education_2_Receiving_gFZl": "2. Revisa que la dirección de entrega y el método de contacto que proporciones sean los correctos.",
  "FoodB_1__GxZN": "Últimos 30 días",
  "FoodB_1106_xaYu_lPMa": "Seguimiento rápido",
  "FoodB_calculator_EeIc_TwiG": "Persona moral",
  "FoodB_B86_xxgH_gxNC": "Incorrecta",
  "FoodB_optimization_Stimulate_contact_xSSH": "Método de contacto preferido",
  "FoodC_202412_AIDx_XZgz": "Editar dirección",
  "FoodB_B86_Kypx_nBHu": "Notas",
  "FoodB_202410_CHeZ_bExg": "Horario",
  "FoodB_0919__mVqa": "Demoras en la entrega",
  "FoodB_B90_jSKX_RucN": "Estado del servicio",
  "FoodB_20260130_UPbX_zUEa": "Fortalecer la comunicación y proyección de confianza",
  "FoodC_cash_WQNI_uYzC": "Agregar",
  "FoodB_boarding_Platform_Delivery_KXsV": "El socio repartidor realiza la entrega",
  "FoodB_420241024_FldG_feZL": "Valor objetivo",
  "FoodB_0919__CONM": "Artículos no disponibles",
  "FoodB_1106_CBkZ_uDVO": "¿Cuáles son los próximos pasos?",
  "FoodB_Contract_tFOZ_SiQZ": "¿Promo registrado?",
  "FoodB_Analysis_Decline_gSax": "Disminución:",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "FoodB_CO_mpOD_dQFB": "Persona natural",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_Contract_BRLH_nPAs": "¿Primera conexión completada?",
  "FoodB_0617_Cgpc_KwbS": "Por favor, ingresa un valor con dos decimales",
  "FoodB_V1_GLnG_kpoL": "Tareas del proyecto",
  "FoodB_II_jpUD_hKgG": "Operaciones",
  "FoodB_2_KsDS_jToj": "Beneficio de descuento en la Tarifa de Servicio por uso de la app",
  "FoodB_Contract_ywoA_Ojgz": "No",
  "FoodB_model2025011603_ztWt_rarX": "Por favor, selecciona primero el método de visita y el tipo de visita",
  "FoodB_signing_sEqL_usdk": "Envía al menos un tipo de documento",
  "FoodB_2_jsYT_EcaJ": "Foto de la información del pago",
  "FoodB_Commision_Cancel_wbtQ": "Cancelar",
  "FoodC_education_4_Customers_laxR": "4. Una vez que el socio repartidor llegue a tu ubicación, tendrás 10 minutos para recibir tu pedido.",
  "FoodOpB_Management_You_can_aDLi": "Para crear la tienda nueva de todos modos, haz clic en “solicitar revisión”. Ten en cuenta que la revisión puede tomar hasta 2 días.",
  "FoodC_202408_cktm_HTVV": "Entendido",
  "FoodC_shop__MWyO": "Límite de compra: {{num}}",
  "FoodB_Translation_ycvD_ntAQ": "Apelación",
  "FoodC_2022__SEQk": "Propina",
  "FoodB_0622_The_statistical_NUCJ": "Los datos se calculan con base en T+1 y se organizan de acuerdo al volumen de ventas de los artículos en los últimos 30 días",
  "FoodB_20250414_BqXP_FPkP": "Tasa de recompra",
  "FoodC_202410_OFhs_UnlA": "Explorar",
  "优惠券": "Cupón",
  "FoodB_250430_YTkG_lNTj": "Nivel de la marca",
  "FoodB_2_Kxtu_brJB": "Nombre completo del contribuyente (nacional)",
  "FoodC_optimization_hksX_yevn": "Agrega la dirección donde se entregará tu pedido.",
  "FoodB_1106_XZeN_ahHQ": "Una vez que hayas terminado de ingresar el contenido, se generará automáticamente un resumen mediante IA.",
  "FoodB_calculator_cctL_sltb": "Total del pedido",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "Si tu pedido llega entre %s y %s minutos después del tiempo de entrega estimado, ",
  "FoodB_CO_jhVR_FWRm": "Cédula de extranjería",
  "FoodB_0921__iLXg": "Cantidad",
  "soda-c-i18n---送您1张%s折扣券；": "Te daremos un cupón del %s de descuento.",
  "FoodB_0919__etPs": "Múltiples promociones",
  "FoodB_20260130_wKpl_lEGS": "Preparación y análisis de datos",
  "FoodB_email_WcaT_rLqN": "El resultado de la visita está incompleto. Por favor, ingresa el resultado de la visita antes de continuar con la optimización.",
  "FoodC_edit_EqUG_FRvo": "Apto./Piso/Habitación",
  "FoodB_communications_udno_SENU": "Hay una o más promociones pendientes de aceptación. Participar en las promociones podría ayudar a impulsar las ventas.",
  "FoodB_calculator_lSyU_ySZI": "¿La tienda está ubicada en Guanajuato?",
  "FoodB_Show_Start_up_nLqS": "Tarifa de Activación",
  "FoodB_CL_Letter_of_EmKs": "Foto del Contrato de Mandato",
  "FoodB_202207_Default_BQmA": "Predeterminado",
  "FoodB_0113_ELbg_zfBg": "Ver info. sobre el asesor de la tienda aquí",
  "FoodB_Analysis_Old_people_fwCy": "Usuarios recurrentes",
  "FoodB_0905__wwdP": "Peso de subartículo",
  "FoodC_edit_ldOR_SyHv": "Ejemplo: “llevo una camisa estampada y estoy esperando en la calle.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "FoodC_improve__ByLg": "Diferente a lo esperado",
  "FoodB_V2_DQvR_Redp": "Usa la función para compartir en la app de BD.",
  "FoodC_optimization_knQx_VpIr": "Agregar",
  "soda-c-i18n---超时赔付规则说明": "Cupón por entrega demorada",
  "FoodB_2_nybf_BGif": "Tarifa de Servicio por uso de la app, con entrega coordinada mediante repartidor registrado en la plataforma",
  "FoodB_20260130_bbbs_MbgJ": "Registro de visitas",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "FoodB_signing_EWhH_awLA": "Selecciona el tipo correcto",
  "FoodC_education__1_IIfh": "(1) Si cancelaste antes de que la tienda haya aceptado el pedido con la función \"Cancelar pedido\" en la sección de Detalles del pedido.",
  "FoodB_20260130_sAvF_Somd": "Calificación de la etapa: resultados de la visita",
  "FoodB_Translation_wHEO_FLQr": "Apelación exitosa",
  "FoodB_0905__vMsv": "{{number}} pedidos más que antes",
  "FoodB_pt3_RLJb_yjel": "Dirección de la tienda",
  "FoodB_Change_caNq_XZum": "¿Es una cocina oculta?",
  "支付": "Pagar",
  "Gattaran_REGULAR_KZHa_qJOa": "Ingresa un número entero",
  "FoodB_Contract_cBzR_gTDZ": "¿Comparación de Precio Estipulada en Contrato?",
  "FoodB_IV_Tips_DFOG": "Alerta",
  "FoodD_messagemanagement_Mail_UMqH": "Correo electrónico",
  "FoodB_V1_baBa_ZZGt": "Encuesta para la tienda",
  "FoodB_2_SwSw_VDmW": "Número de la cuenta bancaria del titular",
  "FoodB_msg_Bank_FoeY": "Banco",
  "FoodB_model20250116_pAHl_Vjqs": "No aprobada",
  "FoodB_20260130_wrHU_Ggnu": "Habilidades de consultoría y diagnóstico",
  "FoodB_comparison_utxs_QFHY": "Confirmar coincidencia",
  "FoodB_signing_kDNC_TCWo": "Recomendamos subir imágenes o archivos como evidencia",
  "FoodB_Analysis_Rise_decline_dZnP": "Incremento:",
  "FoodB_2_unai_MAXI": "Dirección registrada del propietario de la empresa (persona natural)",
  "FoodB_V2_No_store_ahBo": "Falta RFC (Registro Federal de Contribuyentes) *only mx",
  "FoodC_education_In_the_MKeB": "La cancelación no se considerará responsabilidad tuya en las siguientes situaciones:",
  "FoodB_0617_pPbU_koUF": "Hay un contrato de exclusividad con la competencia - U",
  "FoodC_202412_QwDD_sIOi": "Fuera de la zona de entrega",
  "FoodB_20260130_HpAF_xVst": "Relacionamiento y empatía con el usuario",
  "FoodB_subsidy_czaK_LuDh": "La aplicación de Asesor no admite la firma de contratos para este tipo de tienda. Acude a GTR para firmar el contrato.",
  "FoodB_tagging_You_have_ssrJ": "Invalidación solicitada por: 'No es un local comercial'. Para proceder, se requiere adjuntar una fotografía o el número de contacto del representante del establecimiento.",
  "FoodB_20260130_BKrl_bwum": "Fecha de seguimiento",
  "FoodC_improve__ovBF": "Porciones pequeñas",
  "FoodB_0617_RqaF_EHZE": "Fecha de vencimiento del contrato de exclusividad con la competencia - U",
  "FoodB_audit_New_and_yYux": "Diferencia entre el nombre anterior de la tienda y el nuevo",
  "FoodB_Optimization_vVGu_soaV": "Información del propietario",
  "FoodB_20250414_pQls_dkIZ": "Usuarios recurrentes",
  "FoodC_202410_UazG_LTwS": "No hay tiendas disponibles",
  "FoodB_ss_Other_WeRp": "Otro",
  "FoodB_process_mpIE_dSWO": "Rectificación fallida",
  "FoodB_Optimization_xmZs_mwrk": "Posible tienda «Dark Kitchen»",
  "FoodB_governance_coYD_UvmL": "¿Rectificación completada por violación de exclusividad (en línea en multiples platformas)?",
  "FoodB_statistics_hour_MNdW": "Hora",
  "FoodC_202410_hAya_NcZF": "Confirmar ({{countdown}} s)",
  "FoodC_education_In_order_AZCw": "Las recomendaciones para la entrega se crearon con el motivo de ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}. En caso de que haya algún inconveniente relacionado con la entrega, se aplicará lo siguiente.",
  "FoodB_2_RPYQ_YKTN": "Núm. de identificación del contribuyente (CURP)",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Número de Identificación Tributaria Especial)",
  "FoodB_Contract_rrZL_POpC": "El precio de {{brand_name}} es {{unit}} {{number}} % del precio para consumo en el lugar",
  "FoodB_1106_ZsZM_gMYt": "Por favor, resume con la estructura siguiente",
  "FoodC_education__2_KZTZ": "(2) El socio repartidor no pudo contactarte",
  "FoodB_leads_KP_Phone_hCUe": "Teléfono 2 del representante del restaurante",
  "FoodB_Contract_PpIv_FHlg": "¿Recompensa de Tarifa de Servicio incluida en contrato?",
  "FoodB_Wordings_DKwT_wbfI": "Indica por qué elegiste esta opción. Tus comentarios son valiosos y nos ayudan a mejorar.",
  "FoodB_new1_Similarity_ItET": "Similitud",
  "FoodB_V2_iZpC_KKcK": "Compartir reporte de diagnóstico con la tienda",
  "FoodD_Contract_Contract_QzLh": "Contrato",
  "FoodB_1106_vIQn_DUwT": "Alcanzaste el tiempo máximo de grabación de {{max_record_time}} segundos. ¿Comenzar a analizar los datos?",
  "FoodB_B90_GxqM_msid": "Inversión de la plataforma en anuncios",
  "FoodC_20240607_qihL_obWb": "No se encontró la tienda",
  "FoodB_0921__kEaD": "Subsidio%",
  "FoodB_20260130_OgUC_hHHH": "Siempre",
  "FoodC_education_Cancellation_Policy_fxrl": "Política de cancelación",
  "FoodC_202409_rOOL_Peyp": "Ingresar número de celular",
  "FoodB_email_Cebi_VpDl": "Teléfono",
  "FoodB_Analysis_New_customers_vYDl": "Usuarios nuevos",
  "FoodB_up250108_UapS_ZXgM": "Ver ahora",
  "FoodB_v108_kOdQ_AxDe": "ID de la tienda",
  "FoodB_20260130_eCWS_Wotm": "Uso efectivo de herramientas y tecnología",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas vencidas",
  "FoodB_calculator_TJJY_SkoH": "Inversión de la tienda",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Dirección del contribuyente (Nacional)",
  "FoodC_202408_YjqN_Yvyz": "Agrega una dirección para ver tarifa y tiempo",
  "FoodB_1106_rrpW_kMlP": "Resumen de IA",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_email_Bwgs_muyN": "Empleado",
  "FoodD_Dapp_gKJv_HIwo": "Otro",
  "FoodC_202408_IMjl_ywFc": "Cambiar",
  "FoodB_20230410_Qmmi_eYts": "Periodo anterior",
  "FoodC_202410_pHYX_VjbD": "Cerrar",
  "FoodB_model20250116_TRTm_agBI": "Volver",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodB_holidays_wyHK_pzLy": "Abierta",
  "FoodB_2__FNaI": "La misma zona objetivo"
}